import { StageExitSurveyProps } from '../StageZero/types';
import { Stage } from '../../store/missions/types';
import StageSurveyBase from '../StageSurveyBase/StageSurveyBase';
import React from 'react';

const StageExitSurvey: React.FC<StageExitSurveyProps> = (props) => {
    const initialStage = {
        id: props.exitSurveyStage?.id,
        description: undefined,
        surveyDescription: props.exitSurveyStage?.surveyDescription,
        name: props.exitSurveyStage?.name,
        image: props.exitSurveyStage?.image,
        order: props.exitSurveyStage?.order,
    } as Stage;

    return (
        <StageSurveyBase
            inititialStage={initialStage}
            stageExitSurvey={true}
            missionId={props.missionId}
            exercisesData={props.exercisesData}
            skills={props.skills}
            languages={props.languages}
            tasksData={props.tasksData}
            taskType={props.taskType}
        />
    );
};

export default StageExitSurvey;
